import React from 'react';
import { primaryColor } from '../../../utils/comon';

const Stepper = ({ steps, currentStep }) => {
  const currentStepData = steps.find(s => s.id === currentStep) || steps[0];

  return (
    <div className="flex flex-col w-full mt-6 mb-8 select-none max-w-5xl">
      {/* Stepper Header (Mobile only) */}
      <div className="sm:hidden mb-4 text-center">
        <p className="text-[10px] text-gray-400 font-semibold uppercase tracking-[2px]">
          Step {currentStep} of {steps.length}
        </p>
        <h3 style={{ color: primaryColor() }} className="font-bold text-sm uppercase tracking-wider mt-1">
          {currentStepData.label}
        </h3>
      </div>

      <div className="flex items-start w-full">
        {steps.map((step, index) => {
          const active = step.id === currentStep;
          const completed = step.id < currentStep;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.id}>
              {/* Step Circle and Label Block */}
              <div className="flex flex-col items-center flex-none">
                <div
                  className={`w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 transition-all duration-300
                  ${active
                      ? "bg-white font-bold shadow-md shadow-red-50"
                      : completed
                        ? "text-white"
                        : "bg-white border-gray-100 text-gray-300"
                    }`}
                  style={active ? { borderColor: primaryColor(), color: primaryColor() } : completed ? { backgroundColor: primaryColor(), borderColor: primaryColor() } : {}}
                >
                  <span className="text-xs sm:text-sm">{step.id}</span>
                </div>

                {/* Individual Labels (Hidden on mobile) */}
                <div className="hidden sm:block mt-3 text-center">
                  <p
                    className={`text-[9.5px] uppercase font-bold tracking-wider leading-tight whitespace-nowrap px-2
                    ${active || completed
                        ? ""
                        : "text-gray-400"
                      }`}
                    style={(active || completed) ? { color: primaryColor() } : {}}
                  >
                    {step.label}
                  </p>
                </div>
              </div>

              {/* Flexible Connection Line */}
              {!isLast && (
                <div className="flex-1 flex items-center h-9 sm:h-10 px-1 sm:px-2 min-w-[10px]">
                  <div className="w-full h-[1px] transition-colors duration-500" style={{ backgroundColor: completed ? primaryColor() : '#E2E8F0' }} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;